import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20collage%20with%20vibrant%20colorful%20clothing%20pieces%20sneakers%20hoodies%20and%20accessories%20scattered%20creatively%20on%20rich%20terracotta%20and%20warm%20amber%20background%2C%20playful%20magazine-style%20composition%20with%20bold%20color%20blocking%2C%20soft%20studio%20lighting%20with%20gentle%20highlights%2C%20lifestyle%20editorial%20aesthetic&width=1920&height=1080&seq=hero-bg-v2-fashion-collage&orientation=landscape"
          alt="PandabuySpreadsheet fashion finds directory"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/65"></div>
      </div>

      <div className="relative z-10 flex flex-col items-start justify-center h-full w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-none tracking-tight">
            <span className="block">The Most Updated</span>
            <span className="block mt-2">PandabuySpreadsheet</span>
            <span className="block mt-2">Directory for 2026</span>
          </h1>

          <p className="mt-6 text-white/80 text-base md:text-lg max-w-xl leading-relaxed">
            Discover curated <strong className="text-white font-semibold">PandabuySpreadsheet</strong> lists for fashion, shoes, streetwear, and luxury items — updated daily with verified finds.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4 mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 text-base font-semibold rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 whitespace-nowrap hover:bg-white/25 transition-all duration-300"
            >
              pandabuy sheet
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 text-base font-semibold rounded-full bg-primary-500 text-white whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              buy it now
              <i className="ri-shopping-bag-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-8 md:pb-12">
        <p className="font-display text-6xl md:text-8xl lg:text-9xl font-black text-white/10 text-center leading-none select-none whitespace-nowrap">
          PANDABUY.SURF
        </p>
      </div>
    </section>
  );
}